import Chart from 'chart.js/auto';
import Tabs from "./Tabs";
import '../../../../positionning_quiz/css/positioning_quiz.embed.css';

export default class QuizPositioning {
    static initializeEvents() {

        const homePage = document.querySelector('.contain-quiz-home');
        const quiz = document.querySelector('.contain-quiz');
        this.loadingPage()

        if (document.getElementById('start-quiz')) {
            // Remplace la page d'accueil par son quiz
            document.getElementById('start-quiz').addEventListener('click', () => {
                homePage.classList.add('hidden');
                homePage.ariaHidden = 'true';

                quiz.classList.remove('hidden');
                quiz.ariaHidden = 'false';
            });
        }

        this.loadingResultSharedQuiz();

        Array.from(document.querySelectorAll('.quiz')).forEach(element => {
            element.addEventListener('quizEnd', event => {
                const quizEnabledPlugins = event.detail.enabledPlugins;
                const quizContentIdentifier = event.detail.contentId;

                if (quizEnabledPlugins.includes('QuizPositioning') && quizContentIdentifier) {
                    const quizResultElement = document.querySelector('.quiz[data-content-id="' + quizContentIdentifier + '"] .quiz-result');
                    const graphElement = document.getElementById('graph');

                    const buttonReload = document.querySelector('#listButtons');
                    buttonReload.classList.remove('hidden');
                    buttonReload.ariaHidden = 'false';

                    const reloadButton = document.getElementById('reload');
                    reloadButton.addEventListener('click', () => location.reload());

                    const profiles = this.calculatesProfileStatistics();
                    const groupingProfiles = this.profileGrouping(profiles, element.getAttribute('data-profile-groups').split('|').filter(name => name !== '').length);

                    this.displayingTabs(groupingProfiles, element.getAttribute('data-profile-groups').split('|').filter(name => name !== ''));

                    groupingProfiles.forEach((group, index) => {
                        const newGraph = graphElement.cloneNode();
                        document.querySelector('.graphes-content').append(newGraph);
                        this.RenderDoughnutGraph(newGraph, groupingProfiles, index);
                        newGraph.style.removeProperty('display');
                        newGraph.classList.add(index > 0 ? 'hidden' : 'block');
                        newGraph.id = graphElement.id + index;
                        newGraph.dataset.id = graphElement.id + '-' + index;
                    });

                    if (document.getElementById('share-link') !== null) {
                        this.urlAddListResponses()
                        this.shareResultQuiz()
                    }

                    graphElement.remove();

                    this.postResultToJson(quizResultElement, profiles, groupingProfiles, event);

                    Tabs.initializeEvents();
                }
            });
        });
    };

    static slugify(str) {
        if (typeof str == 'string') {
            str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            str = str.toLowerCase(); // convert string to lowercase
            str = str.replace(/[^a-z0-9 -]/g, '')
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-')
                .replace(/^\s+|\s+$/g, '');
            return str;
        }
    }

    static profileGrouping(profiles, tabsNumber) {
        let tab1 = [];
        let tab2 = [];
        let tab3 = [];
        let groupingProfiles = []

        const order = function (tab) {
            return tab.sort((a, b) => b.profileStat - a.profileStat);
        };

        let proportionalityCoefficient = (profileStat) => {
            return (profileStat * 100) / profiles[0].profileStat;
        };

        profiles = order(profiles);
        profiles.forEach(profile => {
            const profileStat = profile.profileStat;
            const coeff = proportionalityCoefficient(profileStat);

            if (tabsNumber === 1) {
                if (profileStat) {
                    if (coeff > 99) {
                        tab1.push(profile);
                    }
                }
                tab1 = order(tab1);
                groupingProfiles = [tab1]
            }

            if (tabsNumber === 2) {
                if (profileStat) {
                    if (coeff > 80) {
                        tab1.push(profile);
                    } else {
                        tab2.push(profile);
                    }
                }
                tab1 = order(tab1);
                tab2 = order(tab2);
                groupingProfiles = [tab1, tab2]
            }

            if (tabsNumber === 3) {
                if (profileStat) {
                    if (coeff > 99) {
                        tab1.push(profile);
                    } else if (coeff >= 60) {
                        tab2.push(profile);
                    } else {
                        tab3.push(profile);
                    }
                }
                tab1 = order(tab1);
                tab2 = order(tab2);
                tab3 = order(tab3);
                groupingProfiles = [tab1, tab2, tab3]
            }
        });

        return groupingProfiles;
    }

    static getRecapAnswers() {
        const allAnswerChecked = Array.from(document.querySelectorAll(':checked'));
        const allQuestionsLabel = Array.from(document.querySelectorAll('.question-label'));
        const groups = {};
        const recapAnswers = [];

        // Regroupement des réponses par question
        allAnswerChecked.forEach(check => {
            const parts = check.id.split('-');
            const key = parts[1];
            if (!groups[key]) groups[key] = [];
            groups[key].push(check);
        });

        // Map temporaire pour éviter les doublons
        const recapMap = new Map();

        allQuestionsLabel.forEach((questionLabel, index) => {
            const questionText = questionLabel.textContent.trim();
            const responses = Object.values(groups)[index] || [];

            const formattedResponses = responses.map(response => ({
                responseText: response?.labels?.[0]?.innerText?.trim().replace(/\n/g, ' ') || "Aucune réponse",
                dataContent: response?.dataset?.title || "Pas de contenu",
                weight: response?.dataset?.weights
            }));

            // Ajoute dans recapMap pour éviter les doublons
            if (!recapMap.has(questionText)) {
                recapMap.set(questionText, {
                    question: questionText,
                    responses: formattedResponses
                });
            }
        });

        // Convertir Map en tableau final
        recapAnswers.push(...recapMap.values());

        return {groups, recapAnswers};
    }

    static calculatesProfileStatistics() {
        const profileStats = {};
        const {groups} = this.getRecapAnswers();
        const {} = this.getRecapAnswers();

        // Mise à jour des statistiques des profils
        Object.values(groups).forEach(groupAnswers => {
            groupAnswers.forEach(answer => {
                let answerData = answer.dataset.weights.split('|'); // Définition en let pour modification
                const locationsId = JSON.parse(answer.dataset.locationsId);

                answerData = answerData.filter(value => value !== '');

                answerData.forEach((detail, index) => {
                    if (detail.includes('-')) { // Vérifie que le format est correct
                        const [weight, name] = detail.split('-');

                        if (!profileStats[name]) {
                            profileStats[name] = {
                                profileStat: 0,
                                locationId: locationsId[index] || null,
                                nameProfile: answer.dataset.title.split('|')[index] || '',
                                descProfile: answer.dataset.desc.split('|')[index] || '',
                            };
                        }

                        profileStats[name].profileStat += parseFloat(weight) || 0;
                    }
                });
            });
        });


        const highestScore = Object.values(profileStats).reduce((max, profileData) => {
            const currentScore = profileData.profileStat;
            return (currentScore > max) ? currentScore : max;
        }, 0);

        Object.keys(profileStats).forEach(profileKey => {
            if (profileKey === "undefined") {
                profileStats[profileKey].nameProfile = 'empty'
                profileStats[profileKey].profileStat = '0'
                profile[profileKey].nameProfile = 'empty'
                profile[profileKey].descProfile = 'empty'
                profile[profileKey].profileStat = '0'
            }
            const profileData = profileStats[profileKey];

            if (profileData.profileStat < (highestScore * 0.40)) {
                delete profileStats[profileKey];
            }
        });

        let sum = 0;
        for (const nameProfile in profileStats) {
            sum += profileStats[nameProfile].profileStat;
        }

        const profilesStat = [];
        for (const name in profileStats) {
            const profileStat = (profileStats[name].profileStat * 100) / sum;
            profilesStat.push({
                nameProfile: profileStats[name].nameProfile,
                profileStat: profileStat,
                locationId: profileStats[name].locationId
            });
        }
        return profilesStat;
    }

    static RenderDoughnutGraph(graphElement, groupingProfiles, indexGraph) {
        const labels = [];
        const data = [];
        let backgroundColors = [];
        let borderWidth = [];
        let spacing = [];

        let newChart = () => {

            groupingProfiles.forEach((section) => {
                section.forEach(item => {
                    labels.push(item.nameProfile);
                    data.push(item.profileStat);
                    backgroundColors.push(indexGraph === groupingProfiles.indexOf(section) ? '#0063CB' : '#EEE');
                    borderWidth.push(indexGraph === groupingProfiles.indexOf(section) ? 7 : 0);
                    spacing.push(indexGraph === groupingProfiles.indexOf(section) ? 15 : 0);
                });
            });

            new Chart(graphElement, {
                type: 'doughnut',
                data: {
                    labels: labels,
                    datasets: [{
                        label: 'Profil',
                        backgroundColor: backgroundColors,
                        borderColor: backgroundColors,
                        offset: spacing,
                        borderJoinStyle: 'miter',
                        borderWidth: borderWidth,
                        data: data,
                        spacing: 10,
                    }]
                },
                options: {
                    cutout: '90%',
                    size: 150,
                    layout: {
                        padding: {
                            right: 20,
                            left: 20
                        }
                    },
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label: function (tooltipItem) {
                                    const dataset = tooltipItem.dataset;
                                    const total = dataset.data.reduce((acc, value) => acc + value, 0); // Somme totale des valeurs
                                    const currentValue = dataset.data[tooltipItem.dataIndex];
                                    const percentage = ((currentValue / total) * 100).toFixed(1).replace('.', ','); // Calcul du pourcentage avec virgule
                                    return `Profil : ${percentage} %`; // Format du texte
                                }
                            }
                        },
                        legend: {
                            display: false
                        }
                    }
                }
            });
        };

        newChart(groupingProfiles);
    }

    static displayingTabs(groupingProfiles, profileGroups) {
        const tabs = document.querySelector('.tabs-list');
        const divElement = document.querySelector('#results');
        let tabsHTML = "";

        const emptyArrays = groupingProfiles.every(subTab => subTab.length === 0);
        if (emptyArrays) {
            // Suppression du bouton PDF
            const pdfButton = document.getElementById('download-pdf');
            pdfButton.classList.add('hidden');
            // Label
            const label = document.querySelector('.quiz-result-label');
            label.innerHTML = "Aucun profil ne correspond à vos réponses.";
            return;
        }

        profileGroups.forEach((profile, index) => {
            const hidden = groupingProfiles[index].length <= 0;

            tabsHTML += `
                <li role="presentation" class="${hidden ? 'hidden' : ''}" aria-hidden="${hidden}">
                    <button data-label="${profile}" 
                            id="tabs-tab-${index + 1}" 
                            class="tabs-tab ${index === 0 ? 'active' : ''}" 
                            role="tab" 
                            aria-selected="${index === 0}" 
                            aria-labelledby="tabs-tab-${index + 1}" 
                            aria-controls="tabs-panel-${index + 1}">
                        ${profile}
                    </button>
                </li>`;
        });

        tabs.innerHTML = tabsHTML;
        this.changeSelectedTab(profileGroups[0]);
        divElement.appendChild(tabs);

        // Affichage des panneaux
        const tabPanels = groupingProfiles.map((profile, index) => {
            const tabPanelHTML = document.createElement('div');
            tabPanelHTML.id = `tabs-panel-${index + 1}`;
            tabPanelHTML.classList.add('tabs-panel');
            tabPanelHTML.role = 'tabpanel';
            tabPanelHTML.style.paddingBottom = '0';
            tabPanelHTML.tabIndex = 0;
            tabPanelHTML.setAttribute('aria-labelledby', `tabs-tab-${index + 1}`);

            // Générer le contenu HTML pour chaque réponse de profil
            tabPanelHTML.innerHTML = Object.values(profile).map(profileAnswer => `
                <div class="mb-3w collapse-group detail-btn-parent">
                    <div class="mb-1w w-full h-5v background-color-grey">
                        <div class="h-full" style="width: ${profileAnswer.profileStat}%; background-color: #0063CB;"></div>
                    </div>
                    <div class="flex flex-column flex-row-sm gap-1w align-items-start justify-content-space-between-sm">
                        <span class="response-label">
                            <strong>${Number.parseFloat(profileAnswer.profileStat).toFixed(1).replace('.', ',')} %</strong> : ${profileAnswer.nameProfile}
                        </span>
                        <button 
                            class="btn secondary p-1w getDetails" 
                            id="${this.slugify(profileAnswer)}"
                            data-location-id="${profileAnswer.locationId}" 
                            data-title="${Number.parseFloat(profileAnswer.profileStat).toFixed(1)}% : ${profileAnswer.nameProfile}"
                            data-percent="${Number.parseFloat(profileAnswer.profileStat).toFixed(1)}%">
                            Voir le détail 
                            <i class="ri-arrow-right-line ml-2w mr-0" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            `).join('');

            return tabPanelHTML;
        });

        // Ajoutez tous les panneaux de manière ordonnée au conteneur
        tabPanels.forEach(tabPanel => divElement.appendChild(tabPanel));

        // Activer le premier panel
        const firstTabPanel = tabPanels[0];
        if (firstTabPanel) {
            firstTabPanel.classList.add('active');
            firstTabPanel.setAttribute('aria-selected', 'true');
        }

        // Boutons "Voir le détail"
        const btnsDetail = document.querySelectorAll('.getDetails');
        btnsDetail.forEach((btn) => {
            btn.addEventListener('click', () => {
                // Attributs du bouton
                const {title: titleBtn, percent: progressBtn, locationId} = btn.dataset;

                const desc = document.getElementById(`desc-${locationId}`)?.textContent ?? '';

                // Ajouter le contenu spécifique du bloc detail
                const blocsDetail = document.querySelectorAll('.contentid-' + locationId);
                if (blocsDetail.length > 0) {
                    document.querySelector('.result-content').innerHTML = "";
                    blocsDetail.forEach(bloc => this.updateQuizResult(titleBtn, desc, progressBtn, bloc.innerHTML));
                }
                this.toggleQuizResult();
                this.enableResultAccordions();

                const buttonReload = document.querySelector('.result-option');
                buttonReload.classList.add('hidden');
            });
        });

        const goBackResultsBtn = document.querySelector('.goBackResults');
        goBackResultsBtn.addEventListener('click', () => this.toggleQuizResult(true));

        // Gérer les clics sur les onglets
        const tabsList = tabs.querySelectorAll('.tabs-tab');

        tabsList.forEach((tab) => {
            tab.addEventListener('click', () => {
                tabsList.forEach((t) => {
                    t.classList.remove('active');
                    t.setAttribute('aria-selected', 'false');
                });

                tabPanels.forEach((panel) => {
                    panel.classList.remove('active');
                    panel.setAttribute('aria-selected', 'false');
                });

                tab.classList.add('active');
                tab.setAttribute('aria-selected', 'true');

                const idActive = tab.id.split('-')[2];

                const activePanel = tabPanels[idActive - 1];
                activePanel.classList.add('active');
                activePanel.setAttribute('aria-selected', 'true');

                this.changeSelectedTab(tab.dataset.label);
                this.changeSelectedGraph([idActive - 1]);
            });
        });
    }

    static shareResultQuiz() {
        const shareLink = document.getElementById('share-link');
        const copyButton = shareLink.querySelector('#copy')
        const linkCopied = document.getElementById('copied');
        linkCopied.style.display='none';

        if (copyButton) {
            copyButton.addEventListener('click', () => {
                copyButton.style.display = 'none';
                copyButton.ariaHidden = 'true';

                linkCopied.ariaHidden = 'false';
                linkCopied.style.display='inline-block';

                setTimeout(function () {
                    copyButton.style.display = 'inline-block';
                    copyButton.ariaHidden = 'false';

                    linkCopied.style.display='none';
                    linkCopied.ariaHidden = 'true';
                }, 3000);
            });
        }
    }

    static enableResultAccordions() {
        const collapses = document.querySelectorAll('.result-content .collapse-button');
        collapses.forEach(collapse => {
            const collapseParent = collapse.closest('.collapse');
            const btnId = collapse.dataset.collapse;
            const accordion = document.querySelector('.result-content #' + btnId);
            if (!accordion) return;

            collapse.setAttribute('aria-expanded', !accordion.hasAttribute('hidden'));
            collapse.addEventListener('click', () => {
                const isExpanded = collapse.getAttribute('aria-expanded') === 'true';
                collapseParent.toggleAttribute('open', !isExpanded);
                collapse.setAttribute('aria-expanded', !isExpanded);
                collapse.toggleAttribute('open', !isExpanded);
                accordion.toggleAttribute('hidden');
            })
        })
    }

    static postResultToJson(quizResultElement, profiles, groupingProfiles, event, recapAnswers = this.getRecapAnswers()) {
        let locationId = event.detail.locationId;
        const pdfButton = document.getElementById('download-pdf');
        const downloadFinished  = document.getElementById('download-finished');

        if (pdfButton) {
            pdfButton.addEventListener('click', event => {
                event.preventDefault();
                pdfButton.textContent = "Téléchargement en cours ...";

                const labels = Array.from(document.querySelectorAll('.tabs-tab'))
                    .map(tab => tab?.innerText || '');

                const canvasImages = Array.from(quizResultElement.querySelectorAll('canvas'))
                    .map(canvas => canvas ? canvas.toDataURL('image/png') : '');

                const allResponses = recapAnswers.recapAnswers
                const dataContainer = profiles.map((profile) => {
                    if (!profile) return null;

                    const element = document.getElementById(profile.locationId);

                    if (!element) return null

                    const data = {
                        locationId: profile.locationId,
                        title: '',
                        contents: [],
                        imgLinks: [],
                        allResponses: [],
                    };

                    // Récupère et stocke tous les titres
                    data.title = Array.from(element.querySelectorAll('.collapse-button .ezstring-field')).map(el => el.textContent.trim());

                    // Récupère toutes les divs avec une classe qui commence par "contentid-"
                    const contentDivs = Array.from(element.querySelectorAll('div[class^="contentid-"] .pdf-content'));

                    // Stocke le texte des divs dans le tableau "contents"
                    data.contents = contentDivs.map(div => div ? div.innerHTML.trim() : '');
                    data.link = contentDivs.map(div => {
                        const linkElement = div ? div.querySelector('a') : null;
                        return linkElement ? linkElement.href : '';
                    })

                    // Récupère et stocke tous les liens src des balises <img>
                    data.imgLinks = Array.from(element.querySelectorAll('img')).map(img => img.src);
                    return data;

                }).filter(item => item !== null); // Filtre les valeurs nulles au cas où certains profils sont manquants


                const resultData = JSON.stringify({
                    canvasImages,
                    groupingProfiles,
                    dataContainer,
                    labels,
                    profiles, // Ajoute les profils pour plus de clarté
                    allResponses
                });

                const requestOptions = {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: resultData
                };

                fetch(`/quiz/download_result/${locationId}/`, requestOptions)
                    .then(response => {
                        if (!response.ok) throw new Error('Network response was not ok.');
                        return response.blob();
                    })
                    .then(blob => {
                        const url = window.URL.createObjectURL(blob); // Create a URL for the Blob
                        const downloadLink = document.createElement('a'); // Create a link element
                        downloadLink.href = url;
                        downloadLink.download = `result_${locationId}.pdf`; // Set the filename for the download
                        downloadLink.click(); // Programmatically click the link to trigger the download
                        window.URL.revokeObjectURL(url); // Clean up the URL object

                        pdfButton.classList.add('hidden');

                        if (downloadFinished) {
                            downloadFinished.classList.replace('hidden', 'inline-block');
                        }

                    })
                    .catch(error => {
                        console.error('Error:', error);
                        pdfButton.textContent = "Erreur de téléchargement";
                    });
            });
        }
    }

    static updateQuizResult(title, desc, progress, content) {
        const titleContainer = document.querySelector('.result-title');
        const descContainer = document.querySelector('.result-desc');
        const progressContainer = document.querySelector('.result-progress');
        const recapTitle = document.querySelector('.recap-title');
        const resultContent = document.querySelector('.result-content');
        const recapAnswersContainer = document.querySelector('.recap-answers');
        const titleTab = title.match(/[^:]+:\s(.*)/);
        const {recapAnswers} = this.getRecapAnswers();

        recapAnswersContainer.innerHTML = `<ul>${recapAnswers.map(({question, responses}) => {
            let totalWeight = 0;

            const responsesHTML = responses.map(({responseText, weight}) => {
                let individualWeight = 0;

                if (weight) {
                    const segments = weight.split("|");

                    segments.forEach(segment => {
                        const middleTextMatch = segment.match(/-(.*?)-/);
                        const middleText = middleTextMatch ? middleTextMatch[1] : "";

                        if (titleTab && titleTab[1] === middleText) {
                            const firstNumberMatch = segment.match(/^\d+(?=-)/);
                            if (firstNumberMatch) {
                                individualWeight = Number(firstNumberMatch[0]);
                                totalWeight += individualWeight; // Ajout du poids total pour la question
                            }
                        }
                    });
                }
                if (individualWeight !== 0) {
                    const pointsText = individualWeight > 1 ? "points" : "point";
                    return `<li>${responseText} (${individualWeight} ${pointsText})</li>`;
                }
            }).join('');
            if (responsesHTML !== '') {
                return `
                <li class="response-item">
                    <span><strong>${question}</strong></span>
                    <ul class="mt-1w mb-2w">
                        ${responsesHTML}
                    </ul>
                </li>`;
            }
        }).join('')}</ul>`;

        titleContainer.textContent = title;
        descContainer.textContent = desc;
        progressContainer.style.width = progress;
        recapTitle.textContent = progress + " de mes réponses correspondent à ce profil";
        resultContent.innerHTML += content;
    }

    static toggleQuizResult(reset = false) {
        const quizResult = document.querySelector('.quiz-result');
        const selectedResult = document.querySelector('.selected-result');
        const resultContent = document.querySelector('.result-content');
        const results = document.querySelector('#results');
        const buttonReload = document.querySelector('.result-option');

        quizResult.classList.toggle('hidden-screen');
        selectedResult.classList.toggle('hidden-screen');
        results.classList.toggle('hidden-screen');
        buttonReload.classList.remove('hidden');

        const toggleAriaHidden = (element) => {
            const isHidden = element.classList.contains('hidden');
            element.ariaHidden = isHidden ? 'true' : 'false';
        }

        toggleAriaHidden(quizResult);
        toggleAriaHidden(selectedResult);
        toggleAriaHidden(results);

        reset
            ? resultContent.innerHTML = ''
            : window.scrollTo(0, document.querySelector('#quiz-embed').offsetTop);
    }

    static changeSelectedGraph(index) {
        const graphes = document.querySelectorAll('.graph-elem');
        graphes.forEach(graph => {
            graph.classList.remove('block');
            graph.classList.add('hidden');
        });
        graphes[index].classList.add('block');
    }

    static changeSelectedTab(label) {
        const quizLabel = document.querySelector('.quiz-result-label');
        quizLabel.textContent = label;
    }

    // Création de l'url à partager
    static urlAddListResponses() {
        const copy = document.getElementById('copy');
        const baseUrl = copy.dataset.copyClipboard;

        const params = Array.from(document.querySelectorAll('fieldset'))
            .map(fieldset =>
                Array.from(fieldset.querySelectorAll('input[type="radio"], input[type="checkbox"]'))
                    .map((input, index) => input.checked ? index : -1)
                    .filter(index => index !== -1)
                    .join(',')
            )
            .join('-');

        copy.dataset.copyClipboard = `${baseUrl}?params=${params}`;
    }


    //refait le quiz avec les paramètres mis dans l'url
    static loadingResultSharedQuiz() {
        const urlParams = new URLSearchParams(window.location.search);
        const params = urlParams.get('params');
        const startQuizButton = document.getElementById('start-quiz');

        if (!params) return;

        if (startQuizButton) startQuizButton.click();

        const responses = params.split('-').map(response => response.split(',').map(Number));
        const quizQuestions = document.querySelectorAll('.quiz-question');
        quizQuestions.forEach((question, index) => {
            const selectedAnswers = responses[index] || [];

            const inputs = question.querySelectorAll('input[type="checkbox"], input[type="radio"]');
            inputs.forEach(input => input.checked = false);

            selectedAnswers.forEach((answerValue) => {
                const checkboxes = question.querySelectorAll('label');

                checkboxes.forEach((checkbox, idx) => {
                    if (idx === answerValue) checkbox.click();
                });
            });

            if (selectedAnswers.length > 0) {
                const intervalId = setInterval(() => {
                    const button = Array.from(question.querySelectorAll('.btn'))
                        .find(btn => btn.textContent.includes('Question suivante') || btn.textContent.includes('Terminer'));

                    if (button && button.offsetParent !== null) {
                        clearInterval(intervalId);
                        setTimeout(() => {
                            if (button.textContent.includes('Question suivante') || button.textContent.includes('Terminer')) {
                                button.click();
                            }
                        }, 0);
                    }
                }, 0);
            }
        });
    }

    // Page de chargement pour les liens partagés
    static loadingPage() {
        const firstPage = document.querySelectorAll('.quiz-view-full, .quiz-view-embed');
        const loading = document.querySelectorAll('.loading');

        firstPage.forEach(div => div.classList.remove('hidden'));
        loading.forEach(loader => loader.classList.add('hidden'));
    }
}